import axios from 'axios';
import getUrl from 'utils/getUrl';
import { generateApiError } from './utils/apiErrorMessages';
import createSurveySubmissionErrors from './submissionErrors/createSurveySubmissionErrors';

const changeName = (collectionPath, entityId, { name }) =>
  axios
    .patch(getUrl.apiV2(`${collectionPath}/${entityId}/name`), { name })
    .catch(
      generateApiError({ submissionErrorMap: createSurveySubmissionErrors }),
    );

export default changeName;
